export default __webpack_public_path__ + "static/media/BillingDetails.b8f111ba.svg";